import React from "react";
import {
  Box,
  Text,
  useColorModeValue,
  Flex,
  Textarea,
} from "@chakra-ui/react";


const CustomizeAIAssistantInstruction = ({ inEditMode = false, instructions, onChange }) => {
  const bgColor = useColorModeValue("gray.100", "gray.700");

  return (
    <Box p={1} bgColor={bgColor} borderRadius="md" width="full" mt={4}>
      <Flex minH="90px" flexDirection="column" gap={2}>
        <Flex flexDirection="column" align="start" ml={4} mr={4}>
          <Text align="start" fontSize="sm" fontWeight="bold" mb={2} mr={4}>
            What important details should the AI know about your practice? You might include appointment booking rules,
            insurance guidelines, call transfer policies,
            general office information, or FAQs. We&apos;ll use these instructions to configure your AI settings.
          </Text>
          <Textarea
            value={instructions || ""}
            isDisabled={!inEditMode}
            height="500px"
            onChange={(e) => {
              onChange(e.target.value)
            }}
          />
        </Flex>
      </Flex>
    </Box>
  )
};

export default CustomizeAIAssistantInstruction;
